import { IconButton, Tooltip } from '@mui/material';
import { RotateCcw } from 'lucide-react';
import { stopTitleBarPress, TITLE_BAR_ICON_SX } from './TileTitleBar';

interface FrameResetButtonProps {
    /** The action's name, shown as its tooltip and read as its label. */
    readonly label: string;
    /** Returns the row's tiles to their patient-aligned planes. */
    readonly onReset: () => void;
}

/** One click back from a turned row frame to the patient-aligned planes. */
export default function FrameResetButton({
    label,
    onReset,
}: FrameResetButtonProps) {
    return (
        <Tooltip title={label} placement="bottom">
            <IconButton
                size="small"
                aria-label={label}
                data-testid="tile-frame-reset"
                sx={TITLE_BAR_ICON_SX}
                onClick={onReset}
                onPointerDown={stopTitleBarPress}
                onMouseDown={stopTitleBarPress}
            >
                <RotateCcw size={12} />
            </IconButton>
        </Tooltip>
    );
}
